// extracted by mini-css-extract-plugin
export default {"column":"Column_column__YYoUp","title":"Column_title__D5Jdk","icon":"Column_icon__LWpAW","cards":"Column_cards__nEZyV"};